import React, {Component} from 'react';

class FJRightWaveIcon extends Component {
    render() {
        return (
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 viewBox="0 0 307 625">
                <g>
                    <path fill='#F8F8F8' d="M82.1,0c-2.3,2.7-3.8,6.1-3.8,10c0,8.4,6.8,15.2,15.2,15.2h56.9c5.2,0,9.5,4.2,9.5,9.5s-4.2,9.5-9.5,9.5H15.2
		C6.8,44.1,0,50.9,0,59.2c0,8.4,6.8,15.2,15.2,15.2h154.5c5.2,0,9.5,4.2,9.5,9.5s-4.2,9.5-9.5,9.5h-29c-8.4,0-15.2,6.8-15.2,15.2
		c0,8.4-6.8,15.2-15.2,15.2H69c-5.2,0-9.5,4.2-9.5,9.5c0,5.2,4.2,9.5,9.5,9.5h55.7c8.4,0,15.2,6.8,15.2,15.2
		c0,8.4,6.8,15.2,15.2,15.2h5.6c5.2,0,9.5,4.2,9.5,9.5c0,5.2-4.2,9.5-9.5,9.5h-43.1c-8.4,0-15.2,6.8-15.2,15.2
		c0,8.4,6.8,15.2,15.2,15.2h78.8c5.2,0,9.5,4.2,9.5,9.5c0,5.2-4.2,9.5-9.5,9.5H90.1c-8.4,0-15.2,6.8-15.2,15.2
		c0,8.4,6.8,15.2,15.2,15.2h70.2c5.2,0,9.5,4.2,9.5,9.5c0,5.2-4.2,9.5-9.5,9.5h-21.5c-8.2,0-14.8,6.4-15.1,14.5H307V0H82.1z"/>
                    <path fill='#F8F8F8' d="M104,325.8c0,8.3,6.7,15,15,15h145.6c5.2,0,9.4,4.2,9.4,9.4c0,5.2-4.2,9.4-9.4,9.4h-95c-8.3,0-15,6.7-15,15
		c0,8.3,6.7,15,15,15h38.1c5.2,0,9.4,4.2,9.4,9.4c0,5.2,4.2,9.4,9.4,9.4h7.1c8.3,0,15,6.7,15,15c0,8.3,6.7,15,15,15h21.7
		c5.2,0,9.4,4.2,9.4,9.4c0,5.2-4.2,9.4-9.4,9.4H162.2c-8.3,0-15,6.7-15,15v0c0,8.3,6.7,15,15,15h34.5c5.2,0,9.4,4.2,9.4,9.4
		c0,5.2,4.2,9.4,9.4,9.4h36.8c8.3,0,15,6.7,15,15c0,8.3-6.7,15-15,15h-5.4c-5.1,0-9.2,4.1-9.2,9.2c0,5.2-4.3,9.5-9.5,9.5h-57.9
		c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15H307c1.1,0-1,0.2,0,0.5V319v0H105.6C104.6,321,104,323.3,104,325.8z"/>
                    <path fill='#F8F8F8'
                          d="M245.8,602.9c-8.3,0-15,6.7-15,15c0,2.2,0.5,4.3,1.3,6.2H307v-21.7c-1,0.3,1.1,0.5,0,0.5L245.8,602.9z"/>
                </g>
            </svg>
        );
    }
}

export default FJRightWaveIcon;